import { combineReducers } from 'redux';

import { initReducer } from './init/reducer';
import { customerReducer } from './customer/reducer';
import { surveyReducer } from './survey/reducer';

export const reducers = combineReducers({
    initReducer,
    customerReducer,
    surveyReducer,
});
